import ModalForm from 'assets/components/form/modalForm/ModalForm';
import ThemeModalFormDefault from 'assets/components/form/modalForm/themes/Theme.ModalForm.Default';
import Icon from 'assets/components/icon/Icon';
import TextInput from 'assets/components/inputs/text/TextInput';
import FormWrapper from 'assets/components/inputs/wrappers/FormWrapper';
import { getLocales } from 'assets/locales/Locale';
import { usePricingDistributionMasterTemplateProvider } from '../PricingDistributionMasterTemplate.Hooks';
import MultilineTextInput from 'assets/components/inputs/multilineText/MultilineTextInput';

export default function PricingDistributionMasterTemplateEdit() {
  const { lang } = getLocales();
  const { selected, pageRouter, saveApi } = usePricingDistributionMasterTemplateProvider();

  return (
    <ModalForm<Api.Core.PricingDistributionMasterTemplate.Save.IRequest>
      subcomponents={ThemeModalFormDefault}
      dependencyArray={[selected]}
      title={lang.pricingDistributionMasterTemplate}
      default={selected?.toJSON() ?? {}}
      onCancel={pageRouter.updateParams}
      onSubmit={saveApi.execute}
      validation={(data, errors) => {
        if (!data.name) errors.name = lang.mustNotBeEmpty;
      }}
      render={({ form }) => (
        <FormWrapper>
          <TextInput
            name="name"
            label={lang.name}
            value={form.data.name}
            error={form.errors.name}
            onChange={form.update}
            icon={<Icon class="if-quill-pen" />}
          />
          <MultilineTextInput
            name="description"
            label={lang.description}
            value={form.data.description}
            error={form.errors.description}
            onChange={form.update}
            icon={<Icon class="if-quill-pen" />}
          />
        </FormWrapper>
      )}
    />
  );
}
